<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-row>
        <el-form-item label="名称" prop="name" style="margin-right:15px">
          <el-input v-model="form.name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="助记符" prop="mnemonic" style="margin-right:15px">
          <el-input v-model="form.mnemonic" placeholder="请输入助记符" />
        </el-form-item>
        <el-form-item label="商品类型" prop="typeCode" style="margin-right:15px">
          <el-cascader
            v-model="form.type"
            :options="data"
            :show-all-levels="false"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="规格" prop="spec" style="margin-right:15px">
          <el-input v-model="form.spec" placeholder="请输入规格" />
        </el-form-item>
        <el-form-item label="条码" style="margin-right:15px">
          <el-input v-model="form.barCode" placeholder="请输入条码" />
        </el-form-item>
        <el-form-item label="辅助单位" prop="auxiliaryUnitCode" style="margin-right:15px">
          <auxiliaryUnitElSelect ref="auxiliaryUnitName" style="width: 100%;" @queryAuxiliaryUnitCode="selectAuxiliaryUnitName" />
        </el-form-item>
        <el-form-item label="单位" prop="unitCode" style="margin-right:15px">
          <unitElSelect ref="unitName" style="width: 100%;" @queryUnitCode="selectUnitCode" />
        </el-form-item>
        <el-form-item label="辅助单位" prop="auxiliaryUnitCode" style="margin-right:15px">
          <auxiliaryUnitElSelect
            ref="auxiliaryUnitName"
            style="width: 100%;"
            @queryAuxiliaryUnitCode="selectAuxiliaryUnitName"
          />
        </el-form-item>
        <el-form-item label="最低库存量预警" prop="miniStock" style="margin-right:15px">
          <el-input v-model="form.miniStock" placeholder="请输入最低库存量预警" />
        </el-form-item>
        <el-form-item label="最高库存量预警" prop="maxStock" style="margin-right:15px">
          <el-input v-model="form.maxStock" placeholder="请输入最高库存量预警" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import unitElSelect from "./unitElSelect.vue";
import auxiliaryUnitElSelect from "./auxiliaryUnitElSelect.vue";
export default {
  name: "GoodsAdd",
  components: {
    unitElSelect,
    auxiliaryUnitElSelect,
    // partyGroupSelect
  },
  data() {
    return {
      num:1,
      form: {
        code: "",
        name: "",
        mnemonic: "",
        typeCode: "",
        spec: "",
        lotNumber: "",
        barCode: "",
        unitCode: "",
        auxiliaryUnitCode: "",
        miniStock: "",
        maxStock: "",
        type: []
      },
      data: [],
      // 所属单位
      unitData: [],
      // 所属辅助单位
      auxiliaryUnitData: [],
      rules: {
        convertedQuantity: [
          { required: true, message: '请选择换算率', trigger: 'blur' },
        ],
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        mnemonic: [
          { required: true, message: "请输入助记符", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        typeCode: [
          { required: true, message: "请输入商品类型", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        spec: [
          { required: true, message: "请输入规格", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        lotNumber: [
          { required: true, message: "请输入批号", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        barCode: [
          { required: true, message: "请输入条码", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        unitCode: [
          { required: true, message: "请输入单位", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        auxiliaryUnitCode: [
          { required: true, message: "请输入辅助单位", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
  },
  methods: {
    handleChange(value) {
        this.form.convertedQuantity = value
    },
    selectUnitCode(value) {
      this.form.unitCode = value;
    },
    selectAuxiliaryUnitName(value) {
      this.form.auxiliaryUnitCode = value;
    },
    findGoodsTypeList() {
      this.loading = true;
      request({
        url: "/ntocc-basic-api/goodsType/queryTreeData",
        method: "get",
        params: { level: 1 }
      }).then(response => {
        this.data = response.data;
      });
    },
    // 提交
    funcSubmit() {
      const length = this.form.type.length;
      if (length > 0) {
        this.form.typeCode = this.form.type[length - 1];
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/goods",
            method: "post",
            params: data
          })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
